<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Katalog Alt Kategori Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span>
                <strong>Not:</strong>
                Katalog alt kategorilerini güncelleyebilir ve çeviri ekleyebilirsiniz.
              </span>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Alt Kategoriler">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>#</th>
                    <th>ALT KATEGORİ ADI</th>
                    <th>KATEGORİ ADI</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable
                    v-model="subCategories"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr v-for="subCategory in subCategories" :key="subCategory.id">
                      <td>{{ subCategory.id }}</td>
                      <td>{{ subCategory.title }}</td>
                      <td>{{ subCategory.category.title }}</td>
                      <td>
                        <b-badge
                          v-if="subCategory.isDraft == false"
                          variant="light-success"
                        >
                          Yayında
                        </b-badge>
                        <b-badge
                          v-if="subCategory.isDraft == true"
                          variant="light-warning"
                        >
                          Taslakta
                        </b-badge>
                      </td>
                      <td>{{ subCategory.createdAt }}</td>
                      <td>
                        <b-button-group class="float-right mr-2">
                          <b-button
                            v-for="language in languages"
                            :key="language.locale"
                            @click="action(subCategory, language.locale)"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="
                              subCategory.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'outline-warning'
                                : 'outline-secondary'
                            "
                            :title="
                              subCategory.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'Düzenle'
                                : 'Ekle'
                            "
                          >
                            {{ language.locale.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>#</th>
                    <th>ALT KATEGORİ ADI</th>
                    <th>KATEGORİ ADI</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="currentPage"
                    :per-page="limit"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getCatalogSubCategories(value, limit)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BPagination,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      languages: [],
      subCategories: [],
      rows: 100,
      limit: 10,
      currentPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getCatalogSubCategories(newVal, this.limit);
      },
      deep: true,
    },
  },
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);
      if (translationControl == undefined) {
        this.$router.push({
          path: `/catalog/sub-categories/create/translation/${node.id}?targetLocale=${locale}&page=${this.currentPage}`,
        });
      } else {
        this.$router.push({
          path: `/catalog/sub-categories/edit/${node.id}?targetLocale=${locale}&page=${this.currentPage}`,
        });
      }
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.subCategories).forEach(([key, value]) => {
        let subCategoriesOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(subCategoriesOrder);
      });
      endpoints
        .putCatalogSubCategoriesOrder(
          { catalogSubCategories: this.request },
          this.limit,
          this.currentPage,
          this.$i18n.locale,
          () => {}
        )
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Katalog alt kategori sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCatalogSubCategories(page, limit) {
      this.currentPage = page;
      endpoints
        .getCatalogSubCategories(page, limit, this.$i18n.locale, () => {})
        .then((data) => {
          this.subCategories = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getCatalogSubCategories(this.currentPage, this.limit);
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
